/**
 * Creates a placeholder implementation for a machine action or guard which
 * can't be implemented in the machine setup, e.g. because it requires hooks,
 * and therefore must be provided when the machine is instantiated. Throws if
 * the machine is run without an implementation having been provided.
 *
 * For an action or guard with params, pass the params type:
 * `makeImplementationWarning<{ error: string }>('setErrorMessage')`.
 */
export function makeImplementationWarning(methodName: string): () => never;
export function makeImplementationWarning<TParams>(
	methodName: string,
): (unusedArgs: unknown, params: TParams) => never;
export function makeImplementationWarning(methodName: string) {
	return () => {
		throw new Error(`${methodName} should be implemented when instantiating`);
	};
}
